module.exports = __webpack_public_path__ + "static/media/album-d6.a46f0ab6.png";